import {z} from "zod/v4-mini"
import {imageLike} from "#template/nodes/image/fundamental"
import {graphNode} from "@cm/graph-v3"
import {MaterialAssignments} from "#template/nodes/material-assignment/material-assignments"
import {objectNodeParameters} from "#template/nodes/object/validation"

export const meshNodeParameters = z.extend(
    z.object({
        subdivisionRenderIterations: z.optional(z.number()),
        displacementTexture: z.optional(imageLike),
        displacementUvChannel: z.optional(z.number()),
        displacementMin: z.optional(z.number()),
        displacementMax: z.optional(z.number()),
        displacementNormalStrength: z.optional(z.number()),
        displacementNormalSmoothness: z.optional(z.number()),
        displacementNormalOriginalResolution: z.optional(z.boolean()),
        materialAssignments: graphNode(MaterialAssignments),
        materialSlotNames: z.record(z.string(), z.string()),
        visibleDirectly: z.boolean(),
        visibleInReflections: z.boolean(),
        visibleInRefractions: z.boolean(),
        receiveRealtimeShadows: z.boolean(),
        castRealtimeShadows: z.boolean(),
    }),
    objectNodeParameters.shape,
)
